import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { InternalChatDropzone } from './InternalChatDropzone';
import { notificationService } from '@/lib/services/notification.service';
import { useFileAttachments } from '../../model/useFileAttachments';
import { useDragEvents } from './hooks';
import { useCurrentAgentId, useIsCurrentAgentUnavailable } from '@/features/chats/stores';

export const ChatDropzone = () => {
  const { t } = useTranslation('chats');
  const { handleFileUpload } = useFileAttachments({});
  const currentAgentId = useCurrentAgentId();
  const isAgentUnavailable = useIsCurrentAgentUnavailable();

  const handleFilesDropped = useCallback(
    async (files: File[]) => {
      if (files.length === 0 || isAgentUnavailable) return;

      try {
        await handleFileUpload(files);
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        notificationService.showError(
          t('chats.chatDropzone.failedToUploadDroppedFiles', { error: errorMessage }),
        );
      }
    },
    [handleFileUpload, isAgentUnavailable, t],
  );

  const { isDragOver } = useDragEvents({
    onFilesDropped: handleFilesDropped,
    agentId: currentAgentId,
  });

  return (
    <div
      className={clsx(
        'fixed inset-0 z-50 transition-colors duration-base',
        isDragOver && 'bg-black/70',
        !isDragOver && 'pointer-events-none',
      )}
    >
      {isDragOver && <InternalChatDropzone />}
    </div>
  );
};
